type LoginRow = { email: string; password: string }
type GlobalVariable = { name: string; init?: string }

/** Turn login rows into project global variables (login_email/login_password, or numbered for many). */
export function buildLoginGlobalVariables(logins: LoginRow[]): Array<{ name: string; init: string }> {
  const vars: Array<{ name: string; init: string }> = []
  const validLogins = logins.filter((login) => login.email.trim() && login.password.trim())
  if (validLogins.length === 1) {
    vars.push({ name: 'login_email', init: validLogins[0]!.email.trim() })
    vars.push({ name: 'login_password', init: validLogins[0]!.password.trim() })
  } else {
    validLogins.forEach((login, index) => {
      const number = index + 1
      vars.push({ name: `login${number}_email`, init: login.email.trim() })
      vars.push({ name: `login${number}_password`, init: login.password.trim() })
    })
  }
  return vars
}

/** Merge saved login rows into a project and make those credentials the active login policy. */
export function mergeProvidedLoginGlobalVariables(
  current: GlobalVariable[],
  logins: LoginRow[],
): GlobalVariable[] {
  const loginVars = buildLoginGlobalVariables(logins)
  const loginNames = new Set(loginVars.map((variable) => variable.name))
  const kept = current.filter(
    (variable) =>
      !/^login\d*_(email|password)$/.test(variable.name) &&
      !loginNames.has(variable.name) &&
      variable.name !== 'login_mode',
  )
  return [...kept, ...loginVars, { name: 'login_mode', init: 'provided' }]
}
